import { useSearchParams } from "react-router-dom";

const PaymentResponse = () => {
    const [searchParams] = useSearchParams();
    const status = searchParams.get("status");
    if (status == "success") {
        return (
            <h1>Success</h1>
        )
    } else if (status == "failed") {
        return (
            <h1>Failed</h1>
        )
    } else {
        return (
            <h1>{status}</h1>
        )
    }
}

export default PaymentResponse